<template>
  <v-container fluid>
    aaaaaaaaaaaaaaaaa
    <v-row ref="_calcRow1">
      <dd-sub-header>
        検索条件
      </dd-sub-header>
    </v-row>
    <v-row ref="_calcRow2">
      <v-col :cols="3">
            <dd-juchu-kensaku-text-box
              ref="jyuchuCd"
              label="受注検索"
              :length="10"
              v-model="conditions.jyuchuCd"
              :required="false"
              :valueType="Ctrls.InputTypes.Free"
              />
      </v-col>
        <v-col :cols="3">
            <dd-juchu-keiyaku-kensaku-text-box
              label="受注契約検索"
              :length="10"
              v-model="conditions.jyuchuKeiyakuCd"
              ref="jyuchuKeiyakuCd"
              :required="false"
              :valueType="Ctrls.InputTypes.Free"/>

      </v-col>
    </v-row>
    <v-row ref="_calcRow2">
      <v-col :cols="3">
            <dd-hacchu-kensaku-text-box
              label="発注検索"
              :length="10"
              v-model="conditions.hacchuCd"
              ref="hacchuCd"
              :required="false"
              :valueType="Ctrls.InputTypes.Free"
              />
      </v-col>
      <v-col :cols="3">
            <dd-hacchu-keiyaku-kensaku-text-box
              label="発注契約検索"
              :length="10"
              v-model="conditions.hacchuKeiyakuCd"
              ref="hacchuKeiyakuCd"
              :required="false"
              :valueType="Ctrls.InputTypes.Free"/>

      </v-col>
    </v-row>
    <v-row ref="_calcRow2">
      <v-col :cols="3">
            <dd-teikei-juchu-kensaku-text-box
              label="定型受注検索"
              :length="10"
              v-model="conditions.tekeiKihonCd"
              ref="tekeiKihonCd"
              :required="false"
              :valueType="Ctrls.InputTypes.Free"
              />
      </v-col>
      <v-col :cols="3">
            <dd-teikei-course-kensaku-text-box
              label="定型コース検索"
              :length="10"
              v-model="conditions.tekeiCorceCd"
              ref="tekeiCorceCd"
              :required="false"
              :valueType="Ctrls.InputTypes.Free"/>

      </v-col>
    </v-row>
    <v-row ref="_calcRow2">
      <v-col>
        <dd-login-button
              label=""
              @click="onDataImport"
              >データ取込</dd-login-button>
      </v-col>
    </v-row>
    <v-footer color="#FFFFFF" app inset>
      <v-row ref="_calcHeight-Footer">
        <dd-footer-button
          @click="onCreateButtonClick">
          受注情報作成処理I
        </dd-footer-button>
        <dd-footer-button
          @click="onUpdateButtonClick">
          受注情報作成処理U
        </dd-footer-button>
      </v-row>
    </v-footer>

  </v-container>

</template>
<script>
import DdSubHeader from '@/components/DdSubHeader'
import DdJuchuKensakuTextBox from '@/components/DdJuchuKensakuTextBox'
import DdJuchuKeiyakuKensakuTextBox from '@/components/DdJuchuKeiyakuKensakuTextBox'
import DdHacchuKensakuTextBox from '@/components/DdHacchuKensakuTextBox'
import DdHacchuKeiyakuKensakuTextBox from '@/components/DdHacchuKeiyakuKensakuTextBox'
import DdTeikeiJuchuKensakuTextBox from '@/components/DdTeikeiJuchuKensakuTextBox'
import DdTeikeiCourseKensakuTextBox from '@/components/DdTeikeiCourseKensakuTextBox'
import DdFooterButton from '@/components/DdFooterButton'
import flowMixin from '@/mixins/flowMixins'
import DdLoginButton from '@/components/DdLoginButton'

export default {
  name: 'JucchuKensaku',
  mixins: [flowMixin],
  data: () => ({
    conditions: {
      jyuchuCd: '',
      jyuchuKeiyakuCd: '',
      hacchuCd: '',
      hacchuKeiyakuCd: '',
      tekeiKihonCd: '',
      tekeiCorceCd: '',
      weight: 0,
      items: 0
    }
  }),
  components: {
    DdSubHeader,
    DdJuchuKensakuTextBox,
    DdHacchuKeiyakuKensakuTextBox,
    DdHacchuKensakuTextBox,
    DdJuchuKeiyakuKensakuTextBox,
    DdTeikeiJuchuKensakuTextBox,
    DdTeikeiCourseKensakuTextBox,
    DdFooterButton,
    DdLoginButton
  },
  computed: {
  },
  created () {
    this.setEnableViewScroll(false)
    this.calcHeightTargets = ['calcRow1', 'calcRow2', 'calcRow3', 'calcFooter']
    this.Effects.loadStart()
    this.$store.dispatch('system/setViewTitle', 'ポップアップテスト画面')
    this.loadLoginInfo()
  },
  mounted () {
    this.refs = this.$refs
    this.Effects.loadComplete()
  },
  methods: {
    onDataImport: function (e) {
      console.log(e)
      this.HttpClient
        .put('/api/v1/D2rcop0050/Exec?id=1000')
        .then((data) => {
          console.log('call end', data)
        })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      const rec = {}
      rec.kihon = []
      rec.meisai = []

      this.HttpClient
        .get(`/api/v1/TrJuchuKihon/find?id=${10000}`)
        .then((data) => {
          rec.kihon[0] = {}
          rec.kihon[0].juchuKihon = data.payload
          rec.kihon[0].juchuKihon.shoriKbn = 'I'

          console.log('■juchuKihon', data.payload)

          this.HttpClient
            .get(`/api/v1/TrJuchuKingaku/find?id=${10000}`)
            .then((data) => {
              rec.kihon[0].juchuKingaku = data.payload

              console.log('■juchuKingaku', data.payload)

              this.HttpClient
                .get(`/api/v1/TrJuchuMeisai/find?id=${10000}`)
                .then((data) => {
                  rec.meisai[0] = {}
                  rec.meisai[0].juchuMeisai = data.payload
                  rec.meisai[0].juchuMeisai.shoriKbn = 'I'

                  console.log('■jjuchuMeisai', data.payload)

                  this.HttpClient
                    .get(`/api/v1/TrJuchuKingaku/find?id=${10001}`)
                    .then((data) => {
                      rec.meisai[0].juchuKingaku = data.payload

                      console.log('■juchuKingaku', data.payload)

                      this.HttpClient
                        .get(`/api/v1/TrJuchuHinmoku/find?id=${10000}`)
                        .then((data) => {
                          rec.meisai[0].juchuHinmoku = []
                          rec.meisai[0].juchuHinmoku[0] = {}
                          rec.meisai[0].juchuHinmoku[0].juchuHinmoku = data.payload
                          rec.meisai[0].juchuHinmoku[0].juchuHinmoku.shoriKbn = 'I'

                          console.log('■juchuHinmoku', data.payload)

                          this.HttpClient
                            .get(`/api/v1/TrJuchuKingaku/find?id=${10002}`)
                            .then((data) => {
                              rec.meisai[0].juchuHinmoku[0].juchuKingaku = data.payload

                              console.log('■juchuKingaku', data.payload)

                              console.log('■rec', rec)

                              this.HttpClient.post('/api/v1/D2comp0050/Exec', rec)
                                .then((data) => {
                                  console.log('■ret', data.payload)
                                })
                            })
                        })
                    })
                })
            })
        })
    },
    onUpdateButtonClick: function (e) {
      console.log(e)
      const rec = {}
      rec.kihon = []
      rec.meisai = []

      this.HttpClient
        .get(`/api/v1/TrJuchuKihon/find?id=${10000}`)
        .then((data) => {
          rec.kihon[0] = {}
          rec.kihon[0].juchuKihon = data.payload
          rec.kihon[0].juchuKihon.shoriKbn = 'U'
          rec.kihon[0].juchuKihon.chumonNo = '888'

          console.log('■juchuKihon', data.payload)

          this.HttpClient
            .get(`/api/v1/TrJuchuKingaku/find?id=${10000}`)
            .then((data) => {
              rec.kihon[0].juchuKingaku = data.payload
              rec.kihon[0].juchuKingaku.kihonUnchin = 888

              console.log('■juchuKingaku', data.payload)

              this.HttpClient
                .get(`/api/v1/TrJuchuMeisai/find?id=${10000}`)
                .then((data) => {
                  rec.meisai[0] = {}
                  rec.meisai[0].juchuMeisai = data.payload
                  rec.meisai[0].juchuMeisai.shoriKbn = 'U'
                  rec.meisai[0].juchuMeisai.ninushiId = 888

                  console.log('■jjuchuMeisai', data.payload)

                  this.HttpClient
                    .get(`/api/v1/TrJuchuKingaku/find?id=${10001}`)
                    .then((data) => {
                      rec.meisai[0].juchuKingaku = data.payload

                      console.log('■juchuKingaku', data.payload)

                      this.HttpClient
                        .get(`/api/v1/TrJuchuHinmoku/find?id=${10000}`)
                        .then((data) => {
                          rec.meisai[0].juchuHinmoku = []
                          rec.meisai[0].juchuHinmoku[0] = {}
                          rec.meisai[0].juchuHinmoku[0].juchuHinmoku = data.payload
                          rec.meisai[0].juchuHinmoku[0].juchuHinmoku.shoriKbn = 'U'
                          rec.meisai[0].juchuHinmoku[0].juchuHinmoku.hinmokuSbt = '888'

                          console.log('■juchuHinmoku', data.payload)

                          this.HttpClient
                            .get(`/api/v1/TrJuchuKingaku/find?id=${10002}`)
                            .then((data) => {
                              rec.meisai[0].juchuHinmoku[0].juchuKingaku = data.payload

                              console.log('■juchuKingaku', data.payload)

                              console.log('■rec', rec)

                              this.HttpClient.post('/api/v1/D2comp0050/Exec', rec)
                                .then((data) => {
                                  console.log('■ret', data.payload)
                                })
                            })
                        })
                    })
                })
            })
        })
    }
  }
}
</script>
